import { useState } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const galleryImages = [
  {
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/dbe7534cbbd0a22ddb8e58c2d63836f2.jpeg',
    alt: 'Allée de mariage',
    category: 'Événementiel',
  },
  {
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/f77c5d1e38fb14144dbefad5ae4929ea.jpeg',
    alt: "Hall d'Entrée",
    category: 'Intérieur',
  },
  {
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/77439906415ee6c0b7449726f7990fa0.jpeg',
    alt: 'Figurine couple mariage',
    category: 'Création 3D',
  },
  {
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/cc48c6313703945e04cfe503229fd76d.jpeg',
    alt: 'Anniversaire adulte prestige',
    category: 'Événementiel',
  },
  {
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/4db849ce555041e83c7486d626c8d5ff.jpeg',
    alt: 'Rendu 3D chambre',
    category: 'Création 3D',
  },
  {
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/19a0cc40440e8fe06cf33e96142b4063.jpeg',
    alt: 'Espace détente bureau',
    category: 'Intérieur',
  },
  {
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/c1787ccf192a21ac8bc2dfb8f0cd3a18.jpeg',
    alt: 'Gala entreprise',
    category: 'Événementiel',
  },
];

const categoryColors: Record<string, string> = {
  'Événementiel': 'bg-brand-fuchsia/80',
  'Intérieur': 'bg-brand-coral/80',
  'Création 3D': 'bg-brand-gold/80',
};

const GallerySection = () => {
  const { ref, isVisible } = useScrollAnimation();
  const [hoveredIdx, setHoveredIdx] = useState<number | null>(null);

  return (
    <section className="bg-brand-beige py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-4">
            <span className="h-px w-6 bg-brand-coral" />
            <span className="text-brand-coral text-xs font-medium tracking-[0.2em] uppercase">Nos inspirations</span>
            <span className="h-px w-6 bg-brand-coral" />
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl text-brand-anthracite mb-4">Notre Galerie</h2>
          <p className="text-brand-gray max-w-lg mx-auto text-base leading-relaxed">
            Un aperçu de quelques inspirations - chaque image communique une énergie et inspire une histoire.
          </p>
        </div>

        {/* Masonry Grid */}
        <div
          ref={ref}
          className={`columns-2 md:columns-3 gap-4 transition-all duration-700 ${isVisible ? 'opacity-100' : 'opacity-0'}`}
        >
          {galleryImages.map((img, idx) => (
            <div
              key={img.alt}
              className="break-inside-avoid mb-4 relative overflow-hidden rounded-xl cursor-pointer group"
              onMouseEnter={() => setHoveredIdx(idx)}
              onMouseLeave={() => setHoveredIdx(null)}
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              {/* Category badge */}
              <div className="absolute top-3 left-3">
                <span className={`text-white text-xs font-medium px-2.5 py-1 rounded-full ${categoryColors[img.category]}`}>
                  {img.category}
                </span>
              </div>
              {/* Overlay */}
              <div
                className={`absolute inset-0 transition-all duration-300 flex items-end p-4 ${
                  hoveredIdx === idx ? 'opacity-100' : 'opacity-0'
                }`}
                style={{ background: 'linear-gradient(to top, rgba(230,62,139,0.7), transparent)' }}
              >
                <p className="text-white text-sm font-medium">{img.alt}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
